<!--进出口信用-->
<template>
  <div class="credit-container">
    <header-index/>
    <div class="credit-content">
      <div class="credit-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+cityList.abridge+'企服务云' }">
            {{ cityList.abridge }}企服务云
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/enterpriseSearch/index' }">企业查询</el-breadcrumb-item>
          <el-breadcrumb-item>进出口信用</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="credit-top">
        <p class="credit-title">查询进出口信用</p>
        <el-input placeholder="请输入企业名称、组织机构代码" v-model="keyword" class="input-with-select" style="width: 45%;"
                  @keyup.enter.native="getImpOrExpCreditInfo">
          <el-button type="danger" slot="append" @click="getImpOrExpCreditInfo">查一下</el-button>
        </el-input>
      </div>
      <div class="credit-info">
        <div class="credit-search-menu">
          <span>最新进出口信用</span>
        </div>
        <div class="credit-list" v-if="creditInfo.length>0">
          <div v-for="info of creditInfo" class="credit-list-item" @click="enterpriseDetails(info)">
            <p class="credit-small-title">{{ info.companyName }}</p>
            <p>
              <span class="credit-gray">海关注册编码：</span>
              <span class="credit-black credit-200">{{ info.regNumber }}</span>
              <span class="credit-gray">注册海关：</span>
              <span class="credit-black credit-120">{{ info.name }}</span>
              <span class="credit-gray">经营类别：</span>
              <span class="credit-black credit-120">{{ info.businessCategory }}</span>
            </p>
          </div>
        </div>
        <div v-else>
          <el-empty description="暂无内容"/>
        </div>
        <page :total="tablePage.total" class="pagination" @currentPage="currentPage" :page="tablePage.currentPage"
              :limit="tablePage.pageSize" style="padding: 0px 25px 15px 10px;"/>
      </div>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>

<script>
import HeaderIndex from "@/components/header/headerIndex";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
import page from "@/components/page/pages";
import cityJson from "@/static/cityJson.json";
import {getImportExportCreditByCid} from '@/api/enterprise_searchApi'
export default {
  name: "impOrExpCredit",
  components: {Hang, Home_footer, HeaderIndex,page},
  data(){
    return{
      keyword: '',
      cid: 0,
      cityList: {},
      creditInfo:[],
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  methods:{
    /*获取进出口信用*/
    getImpOrExpCreditInfo(){
      getImportExportCreditByCid({keyword:this.keyword,page:this.tablePage.currentPage,request:'form'}).then(res=>{
        if (res.code==200){
          this.tablePage.total=parseInt(res.content.total);
          this.creditInfo=res.content.rows;
          console.log(res);
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getImpOrExpCreditInfo();
    },
    /*企业详情*/
    enterpriseDetails(info){
      let routeData = this.$router.resolve({
        name: "enterpriseDetails",
        path: '/enterpriseDetails/index',
        query: {id:info.cid}
      });
      window.open(routeData.href, '_blank')
    }
  },
  mounted() {
    this.getImpOrExpCreditInfo();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    if (sessionStorage.getItem('setPositioning')){
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name){
          this.cityList = li;
        }
      }
    }
  }
}
</script>
<style scoped>
.credit-container >>> .credit-content .credit-top .el-input__inner {
  background-color: #ffffff;
  border-radius: 6px 0px 0px 6px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 16px;
  height: 55px;
  line-height: 55px;
  padding: 0 20px;
  border-right: none;
}

.credit-container >>> .credit-content .credit-top input::-webkit-input-placeholder {
  color: #333333;
}

.credit-container >>> .credit-content .credit-top .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}

.credit-container >>> .credit-content .credit-top .el-icon-search {
  font-size: 19px;
}

.credit-container >>> .credit-content .credit-top .el-input-group__append, .el-input-group__prepend {
  background-color: #FE273B;
  color: #fff;
  border: 1px solid #FE273B;
  border-radius: 0px 6px 6px 0px;
  padding: 0 20px;
}

.credit-container >>> .credit-content .credit-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #666666;
}

.credit-container >>> .credit-content .credit-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.credit-container >>> .credit-content .credit-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.credit-container >>> .credit-content .credit-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.credit-container >>> .credit-content .credit-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}

.credit-container >>> .credit-content .credit-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}

.credit-container >>> .credit-content .credit-breadcrumb .el-breadcrumb__inner a,
.credit-container >>> .credit-content .credit-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}

.credit-container >>> .credit-content .credit-info .credit-search-menu input::-webkit-input-placeholder {
  color: #333333;
}
</style>
<style scoped lang="scss">
.credit-container {
  background: #E7E9F5;
  .credit-content {
    .credit-breadcrumb {
      padding: 10px 18%;
      min-width: 76rem;
      background: #E7E9F5;
    }

    .credit-top {
      background: url("~@/assets/img/enterprise/enterprise_search.png") no-repeat;
      height: 300px;
      min-width: 76rem;
      background-size: 100% 100%;
      text-align: center;
      padding: 0px 18%;
      .credit-title {
        color: #ffffff;
        font-size: 48px;
        font-family: 'SourceHanSansCN';
        cursor: pointer;
        margin-block-start: 0px;
        margin-block-end: 0px;
        padding: 70px 0px 50px;
        font-weight: bold;
      }
    }

    .credit-info {
      margin: 20px 18%;
      background: #FFFFFF;
      padding: 15px 0px;
      min-width: 76rem;
      .credit-search-menu {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #E7E9F5;
        align-items: center;
        padding-bottom: 15px;
        padding-left: 20px;
        padding-right: 20px;

        span {
          font-size: 14px;
          font-family: 'SourceHanSansCN';
          color: #333333;
        }
      }

      .credit-list {
        .credit-list-item {
          border-bottom: 1px solid #E7E9F5;
          padding: 20px;

          .credit-small-title {
            font-size: 18px;
            font-family: 'SourceHanSansCN';
            color: #333333;
            padding-bottom: 15px;
          }

          .credit-gray {
            color: #999999;
            font-size: 14px;
            font-family: 'SourceHanSansCN';
          }

          .credit-black {
            color: #333333;
            font-size: 14px;
            font-family: 'SourceHanSansCN';
          }
          .credit-120{
            min-width: 120px;
            display: inline-block;
          }
          .credit-200{
            min-width: 200px;
            display: inline-block;
          }
          p {
            margin-block-end: 0px;
            margin-block-start: 0px;
            padding-bottom: 5px;
          }
        }
      }
    }
  }
}
</style>